import React from 'react';
import GlobalErrorBoundary from './GlobalErrorBoundary';
import { getGlobalErrorModule } from './redux/module';

const withGlobalErrorBoundary = (WrappedComponent: React.FC<any>) => (
  props: unknown
) => (
  <GlobalErrorBoundary>
    <WrappedComponent {...props} />
  </GlobalErrorBoundary>
);

export const MwithGlobalErrorBoundary = {
  hoc: withGlobalErrorBoundary,
  reduxModules: [getGlobalErrorModule()]
};

export default withGlobalErrorBoundary;
